import { render, staticRenderFns } from "./GroupPostDetail.vue?vue&type=template&id=24ad854d&scoped=true&"
import script from "./GroupPostDetail.vue?vue&type=script&lang=js&"
export * from "./GroupPostDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupPostDetail.vue?vue&type=style&index=0&id=24ad854d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ad854d",
  null
  
)

export default component.exports